"use client";

import { Dumbbell, Trash2, Settings, Clock, Sparkles } from "lucide-react";

const Header = ({
  messages,
  onClearChat,
  onOpenSettings,
  onOpenAddMinutes,
}) => {
  return (
    <header className="fixed top-0 left-0 right-0 z-40 bg-white/95 backdrop-blur-xl border-b border-gray-200/50 shadow-sm">
      <div className="max-w-7xl mx-auto px-2 sm:px-6 py-2 sm:py-3 flex items-center justify-between">
        <div className="flex items-center gap-1 sm:gap-3">
          <div className="relative">
            <div className="w-8 h-8 sm:w-10 sm:h-10 bg-gradient-to-br from-blue-500 via-purple-500 to-pink-500 rounded-xl flex items-center justify-center shadow-lg">
              <Dumbbell className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
            </div>
            <div className="absolute -top-0.5 -right-0.5 w-2 h-2 sm:w-3 sm:h-3 bg-green-400 rounded-full border-2 border-white animate-pulse"></div>
          </div>
          <div>
            <h1 className="text-base sm:text-lg font-bold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent">
              Metabuddy AI
            </h1>
            <p className="text-[10px] sm:text-xs text-gray-500 flex items-center gap-1">
              <Sparkles className="w-2 h-2 sm:w-2.5 sm:h-2.5" />
              <span className="hidden sm:inline">
              CyberGuard
              </span>
              <span className="sm:hidden">Fitness AI</span>
            </p>
          </div>
        </div>
        <div className="flex items-center gap-1 sm:gap-2">
          {/* 
          <button
            onClick={onOpenAddMinutes}
            className="flex items-center gap-1 sm:gap-2 px-2 sm:px-3 py-1.5 sm:py-2 text-white bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 rounded-lg transition-all duration-300 shadow-md hover:shadow-lg hover:scale-105 font-medium text-xs sm:text-sm"
          >
            <Clock className="w-3 h-3 sm:w-4 sm:h-4" />
            <span className="hidden sm:inline">Add Minutes</span>
            <span className="sm:hidden">Add</span>
          </button>*/}
          <button
            onClick={onOpenSettings}
            className="flex items-center gap-1 px-2 sm:px-2.5 py-1.5 sm:py-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100/80 rounded-lg transition-all duration-300 backdrop-blur-sm"
          >
            <Settings className="w-5 h-5 sm:w-4 sm:h-4" />
            <span className="hidden md:inline text-sm">Settings</span>
          </button>
          {messages.length > 0 && (
            <button
              onClick={onClearChat}
              className="flex items-center gap-1 px-2 sm:px-2.5 py-1.5 sm:py-2 text-gray-600 hover:text-red-600 hover:bg-red-50/80 rounded-lg transition-all duration-300 backdrop-blur-sm"
            >
              <Trash2 className="w-5 h-5 sm:w-4 sm:h-4" />
              <span className="hidden md:inline text-sm">Clear</span>
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
